<template>
    <div class="settings-container creator-management" v-if="props.data">
      <!-- can access->100,can veiw only->50,no access->0 -->
      <div class="section-header"><h3>Manage creators</h3></div>
      <div class="setting-item" v-if="props.data.addCreators">
        <span class="setting-label">Add creators</span>
        <Switch v-if="props.canEdit"
        :checked="props.data.addCreators.permission === 100" @click.native="switchItem(props.data, 'addCreators.permission')" />
        <span v-else>{{ switchText(props.data.addCreators.permission) }}</span>
      </div>
      
      <div class="setting-item" v-if="props.data.disableCreators">
        <span class="setting-label">Edit creator's account status</span>
        <Switch v-if="props.canEdit"
        :checked="props.data.disableCreators.permission === 100" @click.native="switchItem(props.data, 'disableCreators.permission')" />
        <span v-else>{{ switchText(props.data.disableCreators.permission) }}</span>
      </div>
      
      <div class="setting-item" v-if="props.data.viewCreatorEarnings">
        <span class="setting-label">View creator earnings</span>
        <Switch v-if="props.canEdit"
        :checked="props.data.viewCreatorEarnings.permission === 100" @click.native="switchItem(props.data, 'viewCreatorEarnings.permission')" />
        <span v-else>{{ switchText(props.data.viewCreatorEarnings.permission) }}</span>
      </div>
      
      <!-- parent -->
      <div class="section-header section-header-2" v-if="props.data.editCreatorInformation">
        <h3>Edit creator settings</h3>
        <el-select v-if="props.canEdit"
          v-model="props.data.editCreatorInformation.permission"
          default-first-option
          @change="handlePermissionChange"
        >
          <el-option v-for="item in props.data.editCreatorInformation.permissionOption" :key="item.type" :label="item.name" :value="item.type" />
        </el-select>
        <span v-else>{{ switchParentText(props.data.editCreatorInformation.permission) }}</span>
      </div>
      <!---->
      
      <div class="setting-item indented" v-if="props.data.editBasicInfo">
        <span class="setting-label">Edit basic info</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.editBasicInfo.permission === 100" @click.native="switchItem(props.data, 'editBasicInfo.permission')" />
          <span v-else>{{ switchText(props.data.editBasicInfo.permission) }}</span>
        </div>
      </div>
      
      <div class="setting-item indented" v-if="props.data.addOrEditCreatorTags">
        <span class="setting-label">Add/edit creator tags</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.addOrEditCreatorTags.permission === 100" @click.native="switchItem(props.data, 'addOrEditCreatorTags.permission')" />
          <span v-else>{{ switchText(props.data.addOrEditCreatorTags.permission) }}</span>
        </div>
      </div>
      
      <div class="setting-item indented" v-if="props.data.editStorefrontPermissions">
        <span class="setting-label">Edit storefront permissions</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.editStorefrontPermissions.permission === 100" @click.native="switchItem(props.data, 'editStorefrontPermissions.permission')" />
        <span v-else>{{ switchText(props.data.editStorefrontPermissions.permission) }}</span>
        </div>
      </div>
      
      <div class="setting-item indented" v-if="props.data.editChatPermissions">
        <span class="setting-label">Edit chat permissions</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.editChatPermissions.permission === 100" @click.native="switchItem(props.data, 'editChatPermissions.permission')" />
          <span v-else>{{ switchText(props.data.editChatPermissions.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.addOrEditContentTag">
        <span class="setting-label">Add/edit content tags to posts</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.addOrEditContentTag.permission === 100" @click.native="switchItem(props.data, 'addOrEditContentTag.permission')" />
          <span v-else>{{ switchText(props.data.addOrEditContentTag.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.importSocialContent">
        <span class="setting-label">Import creator posts</span>
        <div v-if="props.data.editCreatorInformation.permission===100">
          <Switch v-if="props.canEdit"
          :checked="props.data.importSocialContent.permission === 100" @click.native="switchItem(props.data, 'importSocialContent.permission')" />
          <span v-else>{{ switchText(props.data.importSocialContent.permission) }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref,computed } from 'vue';
  import Switch from '@/components/ui/Switch.vue';
  import { useTeamFunction } from './teamFunction';
  import { ElSelect, ElOption } from 'element-plus';

  const props=defineProps({
    data: {
      type: Object,
      default: () => ({})
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  });
  const { switchItem,switchText,switchParentText } = useTeamFunction();
  //no access->0, can view only->50, can access->100
  //+++++++++++++++++++++++++++
  const handlePermissionChange= (event) => {
    let val = event !== 100 ? 0 : 100;
    props.data.editBasicInfo.permission= val;
    props.data.addOrEditCreatorTags.permission= val;
    props.data.editStorefrontPermissions.permission= val;
    props.data.editChatPermissions.permission= val;
    props.data.addOrEditContentTag.permission= val;
    props.data.importSocialContent.permission= val;
  };

  </script>
  
  <style scoped>

  
  </style>